// extracted by mini-css-extract-plugin
module.exports = {"columnGroup":"UISettings-columnGroup-2uVIK"};